const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

// const Backofficebff         : string = "/backofficebff/service/api/v1";
export const GeneralQuery: any = {
    GetCheckOperatorList: Backofficebff + '/v1/generals/check-operator-exist',
    GetCountryList: Backofficebff + '/v1/generals/getcountrylist',
    GetRegionalCountryList: Backofficebff + '/v1/foreign/country/regionalcountries',
    GetAllActiveCountryLanguagesForBackoffice:
        Backofficebff + '/v1/globaldata/get-all-active-country-languages-for-backoffice',
};
